export default function PolicyPage() {
    return (
        <div className="mt-24 mx-auto px-4 container">
            <section className="layout-page text-[#808080] text-[18px] leading-[28px]">
                <h1 className="text-white text-center text-[32px] md:text-[72px] leading-[1.5] 2xl:text-[80px] 2xl:leading-[88px] mb-10">
                    Privacy Policy
                </h1>
                <div className="mb-20">
                    <p>
                        Holdstation Wallet(“HOLDSTATION”), a company incorporated in Vietnam, is committed to protecting and
                        respecting your privacy, managing your personal data transparently and in a fair and lawful manner. This
                        policy is adapted from EU Regulation 2016/679 which provides guidance on the personal information processing
                        rules within the context of General Data Protection Regulation
                    </p>
                    <br />
                    <p>
                        This policy (together with our terms of use, terms and conditions and any other documents referred to
                        herein) sets out the basis on which any personal data we collect from you, or that you provide to us, will
                        be processed by us. Please read the following carefully to understand our practices in processing your data,
                        as well as your rights regarding your personal data and how we will treat it.
                    </p>
                    <p>
                        By visiting our platforms and submitting data to us, you are accepting and consenting to use of your
                        personal data as described in this policy. Please refrain from accessing the platforms if you disagree with
                        the terms of this Privacy Policy.
                    </p>
                    <br />
                    <p>
                        We may change our Privacy Policy from time to time. Any changes we may make to our Privacy Policy in the
                        future will be posted on this page and any such changes will become effective upon posting of the revised
                        Privacy Policy. Please check back frequently to see any updates or changes to our privacy policy. If we make
                        any material or substantial changes to this Privacy Policy, we will inform you by email.
                    </p>
                    <br />
                    <p>
                        For the avoidance of doubt, this Privacy Policy forms a part of the terms and conditions governing your
                        relationship with us and should be read in conjunction with the HOLDSTATION relevant terms and conditions.
                    </p>
                    <br />
                    <h2 className="text-white text-[40px] leading-[48px]">Your Personal Data</h2>
                    <p>
                        We may collect and process personal data provided directly by you; we also process, insofar as necessary,
                        personal data provided to us by third parties, including publicly accessible data, personal data
                        legitimately provided by other group companies and personal data provided by other trusted third parties.
                        You are responsible to provide us with personal data that is correct and inform us of any changes occurring
                        in your data in writing, so that we may take all reasonable measures to keep our records in your regard
                        correct and up to date. You have the choice, at any time, not to provide your Personal Data to HOLDSTATION;
                        however, do note that failure to provide such Personal Data for us to process may result in HOLDSTATION
                        being unable to continue to provide our products or services to you or pursue any contractual relationship
                        which may be in place between us.
                    </p>
                    <br />
                    <p className="text-white text-2xl">Personal Data you give us</p>
                    <p>
                        You may give us personal data about you by filling in forms on the platform or by corresponding with us by
                        phone, e-mail, discord, decentralize apps or otherwise. This includes personal data you provide when you
                        register on the platform, use our services, or when you report a problem with the platform. Examples of such
                        Personal Data you may provide to us may include (depending on the nature of your interaction with us) your
                        name, passport or other identification number, telephone number, mailing address, email address,
                        identification data (such as copies of your identification document or personal photograph) and financial
                        and credit card information, and any other information relating to any individuals which you have provided
                        us in any forms you may have submitted to us, or via other forms of interaction with you. You may also
                        provide us with Personal Data of your officers, employees, agents and customers in order for us to provide
                        you with our products and services.
                    </p>
                    <br />
                    <p className="text-white text-2xl">Personal Data and information we collect about you</p>
                    <p>With regard to each of your visits to our site we may automatically collect the following information:</p>
                    <p>
                        -  technical information, including the Internet protocol (IP) address used to connect your computer to the
                        Internet, your login information, browser type and version, time zone setting, browser plug-in types and
                        versions, operating system, and platform. An IP address is a number that is automatically assigned to your
                        computer when you signed up with an Internet Service Provider. When you visit our website, your IP address
                        is automatically logged in our server. We use your IP address to help diagnose problems with our server, and
                        to administer our website.
                    </p>
                    <p>
                        -  Information about your visit, including the full Uniform Resource Locators (URL) clickstream to, through
                        and from our site (including date and time); products you viewed or searched for; page response times,
                        download errors, length of visits to certain pages, page interaction information (such as scrolling, clicks,
                        and mouse-overs), and
                    </p>
                    <p>
                        methods used to browse away from the page and any phone number used to call our customer service number.
                    </p>
                    <p>
                        - If you contact us or we contact you using the telephone, we may monitor or record the phone call for
                        quality assurance, training and security purposes.
                    </p>
                    <br />
                    <p className="text-white text-2xl">Personal Data we receive from other sources</p>
                    <p>
                        We may receive personal data about you if you use any of the other websites we operate or other services we
                        provide. In this case, we will have informed you when we collected that data that it may be shared
                        internally and combined with data collected on this site. We are also working closely with third parties
                        (including but not limited to, business partners, sub- contractors in technical, payment and delivery
                        services, advertising networks, analytics providers, search information providers, credit reference
                        agencies) and may receive information about you from them.
                    </p>
                    <p>
                        Apart from personal data, we may collect other types of information which is not related to an individual
                        and which is anonymous. For example, the number of website visitors and the number of website users using a
                        particular service. In this way, we hope to improve our customer services.
                    </p>
                    <br />
                    <p className="text-white text-2xl">Processing your personal data</p>
                    <p>
                        We collect and process your personal data, including data provided by you, data we collect about you and
                        data provided by third parties in the following ways and upon the following grounds:
                    </p>
                    <p>
                        -  for the fulfilment of contractual obligations entered into between you and us and to provide you with the
                        information, products and services that you request from us;
                    </p>
                    <p>-  for the fulfilment of legal obligations and legal compliance;</p>
                    <p>-  to notify you about changes to our service;</p>
                    <p>
                        -  to ensure that content from our site is presented in the most effective manner for you and for your
                        computer;
                    </p>
                    <p>
                        -  to provide you with information about other goods and services we offer that are similar to those that
                        you have already purchased or enquired about;
                    </p>
                    <p>
                        -  to provide you, or permit specific third parties to provide you, with information about goods or services
                        we feel may interest you. If you are an existing customer, we will only
                    </p>
                    <p>
                        contact you by electronic means (e-mail or SMS or others) with information about goods and services like
                        those which were the subject of a previous sale or negotiations of a sale to you, subject to your consent.
                        If you are a new customer, and where we permit selected third parties to use your data, we (or they) will
                        contact you by electronic means only subject to your consent.
                    </p>
                    <p>
                        If you do not want us to use your data in this way, or to pass your details on to specific third parties for
                        marketing purposes, you have to the right to withdraw your consent at any time by writing to our Data
                        Protection Officer. Withdrawal of consent does not affect the legality of data processed prior to such
                        withdrawal.
                    </p>
                    <br />
                    <p>
                        To safeguard legitimate company interests which require processing beyond the fulfilment of contractual
                        obligations such as:
                    </p>
                    <p>
                        + Processing of personal data for the purposes of our daily operations including billing and debt
                        collecting;
                    </p>
                    <p>
                        + Processing of personal data for market research, statistical purposes and service and product development;
                    </p>
                    <p>
                        + Processing of your data for the protection of the company’s legal position in the event of legal
                        proceedings;
                    </p>
                    <p>
                        + Processing for the purposes of ensuring network and information security, including preventing
                        unauthorised access to electronic communications networks and stopping damage to computer and electronic
                        communication systems;
                    </p>
                    <p>
                        + Processing for the purpose of reporting possible criminal acts or threats to public security to competent
                        authorities;
                    </p>
                    <p>
                        + To administer our site and for internal operations, including troubleshooting, data analysis, testing,
                        research, statistical and survey purposes;
                    </p>
                    <p>
                        + To improve our site to ensure that content is presented in the most effective manner for you and for your
                        computer;
                    </p>
                    <p>+ To allow you to participate in interactive features of our service, when you choose to do so;</p>
                    <p>
                        + To measure or understand the effectiveness of advertising we serve to you and others, and to deliver
                        relevant advertising to you;
                    </p>
                    <p>
                        + To make suggestions and recommendations to you and other users of our site about goods or services that
                        may interest you or them;
                    </p>
                    <p>
                        + For accurately carrying out and confirming your instructions, for training purposes and/or in order to
                        improve the quality of our customer services. Such data shall include calls, email communication and online
                        chats.
                    </p>
                    <p>
                        You shall have{" "}
                        <b>
                            the right to object to any of the above-mentioned legitimate company interests as a basis for the
                            processing of personal data by contacting our Data Protection Officer
                        </b>
                        . If you submit an objection, we will no longer process your personal data unless we can give evidence of
                        mandatory or legitimate reasons for processing, or processing serves the enforcement, exercise, or defense
                        of our company’s legitimate interests.
                    </p>
                    <br />
                    <p className="text-white text-2xl">Disclosure of your personal data</p>
                    <p>
                        For the Anti-Money Laundering and Counter-Financing Terrorist purposes, HOLDSTATION may forward your data to
                        trusted third parties to be verified and processed. Your personal data may also be provided to trusted
                        third-party processors for the customer care and client communication services, credit reference, fraud
                        prevention, business scoring, credit scoring, placing of monetary deposits, transfer of payments, debt
                        collection and recovery. Such processing shall be conducted in compliance with all legal requirements as
                        well as our Privacy Policy and strict retention policies and codes of conduct. We will ensure that all
                        companies to which we disclose your Personal Data will only process it in accordance with our instructions
                        and on our behalf, and that they shall only use such data to the extent to which we ourselves are entitled.
                    </p>
                    <p>
                        We may share your personal data with any member of our group of companies, which means our subsidiaries and
                        our ultimate holding company and its subsidiaries.
                    </p>
                    <p>We may share your personal data with selected third parties including:</p>
                    <p>
                        -  Business partners, suppliers and sub-contractors for the performance of any contract we enter into with
                        them;
                    </p>
                    <p>
                        -  Analytics and search engine providers that assist us in the improvement and optimisation of our site;
                    </p>
                    <p>
                        -  Credit reference agencies, due diligence agencies or ID verification agencies or service providers for
                        the purpose of Anti-Money Laundering and Counter-Financing Terrorist.
                    </p>
                    <p>
                        We may disclose your personal data to third parties for the purpose of fulfilling legitimate company
                        interests:
                    </p>
                    <p>
                        -  In the event that we sell or buy any business or assets, in which case we may disclose your personal data
                        to the prospective seller or buyer of such business or assets;
                    </p>
                    <p>
                        -  If HOLDSTATION or substantially all of its assets are acquired by a third party, in which case personal
                        data held by it about its customers will be one of the transferred assets;
                    </p>
                    <p>
                        -  If we are under a duty to disclose or share your personal data in order to comply with any legal
                        obligation, or in order to enforce or apply our terms of use and other agreements; or to protect the rights,
                        property, or safety of HOLDSTATION, our customers, or others. This includes exchanging data with other
                        companies and organisations for the purposes of fraud protection and credit risk reduction;
                    </p>
                    <p>-  For the purposes of billing, debt collecting credit rating and verification and fraud prevention;</p>
                    <p>-  For the protection of the company’s legal position in the event of legal proceedings.</p>
                    <p>
                        We will ensure that all companies to which we disclose your Personal Data will only process it in accordance
                        with our instructions and on our behalf, and may only use such data to the extent to which we ourselves are
                        entitled. All such companies and third parties will further be required by us to meet the requirements of
                        data protection legislation and our strict privacy and retention policies to keep your data secure at all
                        times.
                    </p>
                    <p>
                        We may, if necessary or authorised by law, provide customer data to law enforcement agencies, regulatory
                        organisations, courts or other public authorities. We attempt to notify our customers about legal demands
                        for their Personal Data unless prohibited by law or court order or when the request is an emergency. We may
                        dispute such demands when we believe that the requests are disproportionate, vague or lack proper authority,
                        but we do not promise to challenge every demand.
                    </p>
                    <p>
                        Your personal data shall not be processed for purposes other than those it was collected for; should further
                        processing be required, you will be informed of that purpose and provided with all necessary information.
                    </p>
                    <p>
                        You shall have the right to object to any of the above-mentioned legitimate company interests as a basis for
                        the processing of personal data and to forward any queries you may have by contacting our Data Protection
                        Officer. If you submit an objection, we will no longer process your personal data unless we can give
                        evidence of mandatory, legitimate reasons for processing, which outweigh your interests, rights, and
                        freedoms, or processing serves the enforcement, exercise, or defence of interests.
                    </p>
                    <br />
                    <p className="text-2xl text-white">Storing of data</p>
                    <p className="text-2xl text-white">Where we store your personal data</p>
                    <p>
                        The security of your Personal Data is our top priority. HOLDSTATION takes all physical, technical and
                        organisational measures needed to safeguard Personal Data. We will use all reasonable efforts to protect
                        your information in a highly secure data centre, adhering to strict computer security standards. We have put
                        in place, privacy protection control systems designed to ensure that our customers’ information remains
                        safe, secure and private.
                    </p>
                    <p>
                        Access to Personal Data is only limited to authorised personnel of HOLDSTATION who are fully trained in
                        handling your information. These authorised personnel are required to ensure the confidentiality of your
                        information and to respect your data protection rights at all times. Personnel who have access to your
                        information will be subjected to disciplinary action should they fail to observe this Privacy Policy and
                        other guidelines, code of conduct or policies which we may issue to them from time to time.
                    </p>
                    <p>
                        The data that we collect from you may be transferred to, and stored at, via third parties for certain
                        purposes. It may also be processed by staff who work for us or for one of our suppliers. Such staff maybe
                        engaged in, among other things, the fulfilment of your order, the processing of your payment details and the
                        provision of support services. By submitting your personal data, you agree to this transfer, storing or
                        processing. We take all steps reasonably necessary to ensure that your data is treated securely using
                        sufficient and appropriate safeguards and in compliance with all legal requirements as well as this Privacy
                        Policy and our strict codes of conduct.
                    </p>
                    <p>
                        All personal data you provide to us is stored on our secure servers. Any payment transactions will be
                        encrypted using SSL technology. Where we have given you (or where you have chosen) a password which enables
                        you to access certain parts of our site, you are responsible for keeping this password confidential. We ask
                        you not to share a password with anyone.
                    </p>
                    <p>
                        Unfortunately, the transmission of information via the internet is not completely secure. Although we will
                        do our best to protect your personal data, we cannot guarantee the security of your data transmitted to our
                        site; any transmission is at your own risk. Once we have received your data, we will use strict procedures
                        and security features to try to prevent unauthorised access.
                    </p>
                    <p>
                        In line with applicable law, we shall, where lawfully obliged, notify the competent authorities and/or you
                        in cases of personal data breach and will keep a log of any such breaches.
                    </p>
                    <br />
                    <p className="text-2xl text-white">For how long will your data be stored?</p>
                    <p>
                        We will process and store your personal data for as long as it is necessary in order to fulfill our
                        contractual, regulatory and statutory obligations. We will assess and respond to requests to delete data and
                        we shall accordingly delete data provided that the data is no longer required in order to fulfill
                        contractual, regulatory or statutory obligations, or the fulfillment of any obligations to preserve records
                        according to law.
                    </p>
                    <p>
                        We will normally retain your records for a minimum of five years to comply with legal, regulatory and
                        contractual requirements unless there is a particular reason to hold the records for longer; your personal
                        data may be retained for longer periods in the event of prospective or pending debt collecting, legal or
                        law-enforcement proceedings and until such proceedings are formally and definitively concluded.
                    </p>
                    <br />
                    <p className="text-2xl text-white">Your rights</p>
                    <p>In relation to your personal data, you have the right to:</p>
                    <p>-  access to your personal data;</p>
                    <p>-  the rectification of your personal data;</p>
                    <p>-  restrict processing;</p>
                    <p>-  object to processing;</p>
                    <p>-  data portability;</p>
                    <p>-  request erasure of your personal data.</p>
                    <p>
                        You shall also have the right to ask us not to process your personal data for marketing purposes. We will
                        seek your explicit consent (before collecting your data) if we intend to use your data for such purposes or
                        if we intend to disclose your information to any third party for such purposes. You can exercise your right
                        to prevent such processing by checking certain boxes on the forms we use to collect your data. You can also
                        withdraw your consent by contacting our Data Protection Officer.
                    </p>
                    <p>
                        Our site may, from time to time, contain links to and from the websites of our partner networks, advertisers
                        and affiliates. If you follow a link to any of these websites, please note that these websites have their
                        own privacy policies and that we do not accept any responsibility or liability for these policies. Please
                        check these policies before you submit any personal data to these websites.
                    </p>
                    <br />
                    <p className="text-2xl text-white">Access to Data</p>
                    <p>
                        {" "}
                        You have the right to request, free of charge, access to and a copy of your personal data as processed by
                        us.
                    </p>
                    <br />
                    <p className="text-2xl text-white">Automatic Decision Making</p>
                    <p>
                        In establishing and carrying out our business relationship, we generally do not make use of fully automated
                        decision making. If we use this procedure in individual cases, we shall inform you of this separately,
                        provided it is a legal requirement.
                    </p>
                    <br />
                    <p className="text-2xl text-white">Contact</p>
                    <p>
                        Questions, comments and requests regarding this Privacy Policy are welcomed and should be addressed to
                        Holdstation’s officer.
                    </p>
                </div>
            </section>
        </div>
    );
}
